import React from "react";
import { ChevronRight } from "lucide-react";

const LABEL_MAP = {
  not_in_uptrend: "Stock daily price < Supertrend(7,3)",
  not_enough_5m_candles: "Insufficient 5-min data yet",
  no_daily_data: "Daily OHLC fetch returned nothing",
  fetch_failed: "Upstox fetch timed out / failed",
  body_ratio_below_50pct: "Indecision candle (body < 50% range)",
  rsi_below_50: "Daily RSI(14) below 50 (weak momentum)",
  underlying_below_50: "Underlying below ₹50",
  volume_not_increasing: "Volume not monotonically rising v1<v2<v3",
  no_candle_touches_vwap: "No low pulled into 0.5% VWAP zone",
  candle_closed_below_vwap: "Last 3 candles closed below VWAP",
  no_qualifying_pattern: "Neither 2-strong-breakout nor pullback pattern matched",
  rule1_first_candle_not_green: "First 5-min candle wasn't green",
  rule2_second_open_not_above_first_close:
    "Second 5-min candle didn't open above the first's close",
  rule3_latest_close_not_above_second_high:
    "Latest close didn't break the second candle's high",
  rule4_supertrend: "Daily Supertrend gate failed (price ≤ Supertrend)",
  rule5_vwap: "Daily VWAP gate failed (price ≤ daily VWAP)",
  no_instrument_key: "Couldn't resolve Upstox instrument key",
  bad_candle_data: "Malformed OHLCV from Upstox",
  // S6 OI reasons
  correction_mode_active: "OI correction-mode is active (vol surge + price drop)",
  not_two_consecutive_bearish: "Last 2 candles weren't both red",
  close_above_or_equal_vwap: "Current close ≥ intraday VWAP",
  current_high_not_lower_than_prev: "Higher high relative to prior candle",
  bear_volume_not_dominant: "Bear-side volume not dominant",
  insufficient_candles: "Not enough candles to evaluate",
  candle_fetch_failed: "Couldn't fetch this symbol's candles",
  score_below_threshold: "Score (OI% × price%) below the quality floor",
  multi_tf_bullish_count_below_threshold: "Less than 3/3 timeframes bullish (5m/1h/1d)",
  price_too_extended_vs_vwap: "Price chased too far above VWAP",
  sector_trend_bearish: "Underlying's sector is bearish today",
  no_atm_strike_or_ltp: "ATM option chain missing strike / LTP",
  oi_feed_unavailable: "Upstox OI feed unavailable (token missing or API down)",
  market_closed: "Markets are closed (Mon-Fri 09:15-15:30 IST only)",
  all_candidates_dropped_pre_scoring: "All candidates dropped before scoring (price/VWAP gates)",
};

export const RejectionSummaryPanel = ({
  testid,
  title,
  slot,
  rejectionSummary,
  universeSize,
  extraBadges = null,
  footerNote = null,
}) => {
  const entries = Object.entries(rejectionSummary || {}).sort(
    (a, b) => b[1] - a[1]
  );
  if (entries.length === 0) return null;

  return (
    <div
      className="border border-grid p-4 space-y-3"
      data-testid={testid}
    >
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-3 font-mono-data flex items-center gap-2">
          <ChevronRight size={12} /> {title} · Last slot: {slot || "—"}
        </div>
        <div className="text-[10px] font-mono-data text-muted-2 flex items-center gap-3">
          {universeSize != null && <span>Universe {universeSize}</span>}
          {extraBadges}
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {entries.slice(0, 10).map(([reason, count]) => (
          <span
            key={reason}
            className="inline-flex items-center gap-1.5 px-2 py-1 border border-grid text-[10px] font-mono-data"
            title={LABEL_MAP[reason] || reason}
          >
            <span style={{ color: "var(--bear)" }}>{count}</span>
            <span className="text-muted-2">{reason}</span>
          </span>
        ))}
      </div>
      {footerNote && (
        <div className="text-[10px] text-muted-3 font-mono-data leading-relaxed">
          {footerNote}
        </div>
      )}
    </div>
  );
};
